import { useNavigate,useLocation } from 'react-router-dom';
import {  getLabPadvishRequestList, getPadvishRequestLicense, getPadvishRequestList, padvishLicenseInstallation, padvishLicenseTransfer, updatePadvishLicenseStatus } from "../../api/api"
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks"
import { errorNotify, sucessNotify } from "../../services/toast.notification"
import { useEffect, useState } from 'react';
import { Col, Dropdown, Input, Menu, Modal, Row, Space } from 'antd';
import CustomTable from '../../components/_common/Table';
import Table, { ColumnsType } from 'antd/lib/table';
import { DownOutlined, DollarOutlined, BuildOutlined, DeliveredProcedureOutlined } from '@ant-design/icons';
import { UpdatePadvishRequestLicenseList } from '../../redux/reducers/PadvishRequestLicenseSlice';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Spinner from '../../components/_common/Spinner';
import FormContainer from '../../components/FormContainer/FormContainer';

const PadvishLicenseRegistration = () =>{
    const {state} = useLocation();
    const { requestId } = state; // Read values passed on state
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [permission,setPermission] = useState(true);
    const [accountStatusValue,setAccountStatusValue] = useState(0);
    const [showLicenseCountDialog,setShowLicenseCountDialog] = useState(false);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [currentLicenseCount,setCurrentLicenseCount] = useState(0);
    const [selectedAccountId,setSelectedAccountId] = useState(0);
    const [licenseCount,setLicenseCount] = useState(0);
    const [cancellation,setCancellation] = useState(false);
    const [showRequestListDialog,setShowRequestListDialog] = useState(false);
    const [padvishRequestList,setPadvishRequestList] = useState([]);
    
    const [expandedRowRender]=useState([
        {title:'نام کامپیوتر',val:'str_ConsoleComputerName'}
        ,{title:'IP کامپیوتر',val:'str_ConsoleComputerIp'}
        ,{title:'کد لایسنس',val:'str_licenseCode'}
        ,{title:'وضعیت',val:'str_Status'}
        ,{title:'تعداد کاربر',val:'int_UserCountlicense'}
        ,{title:'تاریخ انقضا',val:'str_licenseExpireDate'}
        ,{title:'تاریخ نصب',val:'str_InstallDate'}
        
    ]);
    const columns: ColumnsType<any> = [
        
        {
            title: 'عملیات', 
            width: 70 , dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Dropdown overlay={menu(record)}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            <DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            )
        },
        Table.EXPAND_COLUMN,
        { title: 'نام کامپیوتر', dataIndex: 'str_ConsoleComputerName', key: 'str_ConsoleComputerName', width: 150},
        { title: 'IP کامپیوتر ', dataIndex: 'str_ConsoleComputerIp', key: 'str_ConsoleComputerIp', width: 150 },
        { title: 'کد لایسنس', dataIndex: 'str_licenseCode', key: 'str_licenseCode' , width: 150},
        { title: 'وضعیت ', dataIndex: 'str_Status', key: 'str_Status', width: 150 },
        { title: 'تعداد کاربر', dataIndex: 'int_UserCountlicense', key: 'int_UserCountlicense', width: 150 },
        { title: 'تاریخ انقضا', dataIndex: 'str_licenseExpireDate', key: 'str_licenseExpireDate' , width: 150 },
        {title:'تاریخ نصب',dataIndex:'str_InstallDate', key: 'str_InstallDate' , width: 150 },
];

const padvishcolumns: ColumnsType<any> = [
    { title: 'آزمایشگاه', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName', width: 150},
    { title: 'تعداد کاربر', dataIndex: 'int_CountUserPadvish', key: 'int_CountUserPadvish', width: 150 },
    { title: 'وضعیت', dataIndex: 'str_Status', key: 'str_Status' , width: 150},
    { title: 'تاریخ درخواست', dataIndex: 'str_RequestDate', key: 'str_RequestDate', width: 150 },
    { title: 'تایید مالی', dataIndex: 'str_FinancialApproveDate', key: 'str_FinancialApproveDate', width: 150 },
    { title: 'نصاب', dataIndex: 'str_FullName', key: 'str_FullName' , width: 150 },
    {title:'تاریخ اتمام کار',dataIndex:'str_FinilizeDate', key: 'str_FinilizeDate' , width: 150 },
];

const menu = (record: any) => (
    <Menu
        items={[
            // {
            //     key: "1",
            //     label:record.bit_Deleted? "بازیابی" : "حذف",
            //     onClick: () => removeRequest(record.prk_TemperatureRequest_AutoID, record.bit_Deleted? false :true),
            //     icon: <DeleteOutlined />,
            //     disabled: !(myStore.auth.loginType === 'parsicuser') || !permission ,
            //     danger: true
            // },
            {
                key: "2",
                label: "نصب",
                onClick: () => padvishLicenseInstallationClick(record.prk_PadvishLicenseInfo_AutoID),
                icon: <DollarOutlined />,
                disabled: !(myStore.auth.loginType === 'parsicuser'  && record.int_Status == 0) || !permission

            },
            {
                key: "3",
                label: "تمدید",
                onClick: () => confirmAlertClick(1,record.int_UserCountlicense,record.prk_PadvishLicenseInfo_AutoID),
                icon: <BuildOutlined />,
                disabled: !(myStore.auth.loginType === 'parsicuser' ) || !permission

            },
            {
                key: "4",
                label: "ارتقا",
                onClick: () => confirmAlertClick(2,record.int_UserCountlicense,record.prk_PadvishLicenseInfo_AutoID),
                icon: <DeliveredProcedureOutlined />,
                disabled: !(myStore.auth.loginType === 'parsicuser') || !permission
            },
            {
                key: "5",
                label: "کاهش",
                onClick: () => confirmAlertClick(3,record.int_UserCountlicense,record.prk_PadvishLicenseInfo_AutoID),
                icon: <DeliveredProcedureOutlined />,
                disabled: !(myStore.auth.loginType === 'parsicuser') || !permission
            },
            {
                key: "6",
                label: "ابطال",
                onClick: () => updatePadvishLicenseStatusClick(record.prk_PadvishLicenseInfo_AutoID,4,0),
                icon: <DeliveredProcedureOutlined />,
                disabled: !(myStore.auth.loginType === 'parsicuser' ) || !permission
            },
            {
                key: "7",
                label: "انتقال",
                onClick: () =>
                { 
                    loadPadvishRequest()
                    setShowRequestListDialog(true)
                    setSelectedAccountId(record.prk_PadvishLicenseInfo_AutoID)
                },//padvishLicenseTransferClick(record.prk_PadvishLicenseInfo_AutoID,1),
                icon: <DeliveredProcedureOutlined />,
                disabled: !(myStore.auth.loginType === 'parsicuser' && record.int_Status ===4 && record.bit_Expire === 0  ) || !permission
            },
           
        ]}
    />
)

const confirmAlertClick = (accountStatus:Number,licenseCount:number,accountId:Number) => {
    setAccountStatusValue(Number(accountStatus));
    setCurrentLicenseCount(Number(licenseCount));
    setSelectedAccountId(Number(accountId));

    confirmAlert({
      title: "",
      message: "آیا می‌خواهید روی همین لایسنس اعمال شود؟",
      buttons: [           
        {
          label: "خیر",
           onClick: () =>{ 
            errorNotify("وضعیت لایسنس فعلی به حالت ابطال تغییر خواهد یافت.")
            navigate("/"+myStore.auth.loginType+"/NewPadvishRequestLicense" , { state: { requestId,accountId} })
        }

        },
        {
            label: "بله",
            onClick: () => setShowLicenseCountDialog(true)
          }
      ]
    });
  };

  const loadPadvishRequest = () => {
    setIsLoading(true);

    if(myStore.auth.loginType === "parsicuser")
    {
        getPadvishRequestList()
        .then((result: any) => {           
           setPadvishRequestList(result.data.data)
            setIsLoading(false);
        })
        .catch((error) => {
            console.log(error);
            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })
    }
    else{
        getLabPadvishRequestList(myStore.auth.userId?myStore.auth.userId:0)
        .then((result: any) => {
            setPadvishRequestList(result.data.data)
            setIsLoading(false);
        })
        .catch((error) => {
            setIsLoading(false);

            console.log(error);
            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })
    }
    

}

    const loadPadvishRequestLicenses = () => {
         getPadvishRequestLicense(requestId)
            .then((result: any) => {           
                dispatch(UpdatePadvishRequestLicenseList({ padvishRequestLicenseList: result.data.data }))
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
        }
    

    const addNewOnClick = () => {
        navigate("/"+myStore.auth.loginType+"/NewPadvishRequestLicense" , { state: { requestId,accountId:0} })
    }

   
    const licenseRegistrationClick = (requestId:Number) => {
        navigate('/parsicuser/padvishLicenseRegistration', { state: { requestId} });
    }

    const padvishLicenseInstallationClick = (accountId:Number) =>{
        setIsLoading(true);
        padvishLicenseInstallation(accountId,requestId)
        .then((result: any) => {
            sucessNotify("وضعیت لایسنس به حالت نصب شده تغییر یافت.");
            loadPadvishRequestLicenses();

         setIsLoading(false);
        })
        .catch((error) => {
            console.log(error);
            setIsLoading(false);

            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })
    }

    const padvishLicenseTransferClick = (accountId:Number,transferId:Number) =>{
        setIsLoading(true);
        padvishLicenseTransfer(accountId,transferId)
        .then((result: any) => {
            sucessNotify("وضعیت لایسنس به حالت انتقال شده تغییر یافت.");
            loadPadvishRequestLicenses();

         setIsLoading(false);
        })
        .catch((error) => {
            console.log(error);
            setIsLoading(false);

            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })
    }


    const updatePadvishLicenseStatusClick = (accountId:Number,statusCode:Number, licenseCount:Number) =>{
        setIsLoading(true);
        updatePadvishLicenseStatus(accountId,requestId,licenseCount,statusCode)
        .then((result: any) => {
            sucessNotify("وضعیت لایسنس تغییر یافت.");
            loadPadvishRequestLicenses();

         setIsLoading(false);
        })
        .catch((error) => {
            console.log(error);
            setIsLoading(false);

            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })
    }

    const onSubmitForm = (e:any) => {
        e.preventDefault();
  
        setIsSubmiting(true)

         setIsLoading(true);
        updatePadvishLicenseStatus(selectedAccountId,requestId,licenseCount,accountStatusValue)
        .then((result: any) => {
            sucessNotify("وضعیت لایسنس تغییر یافت.");
            loadPadvishRequestLicenses();

         setIsLoading(false);
         setIsSubmiting(false);
         setShowLicenseCountDialog(false);
        })
        .catch((error) => {
            console.log(error);
            setIsLoading(false);

            errorNotify(error.response.data.errorMessage, undefined, 5000)
        })

    }


    const handleChange = (e:any) =>{
        const { name, value } = e.target;
        //alert(value);
        setLicenseCount(value);
    }

    const handleOk = () => {
        setShowRequestListDialog(false);
      };
    
      const handleCancel = () => {
        setShowRequestListDialog(false);
      };

    useEffect(() => {
        loadPadvishRequestLicenses();
    }, [])
    return(
        <>
        <Row>
                <CustomTable 
                columns={columns} 
                expandedRowRender={expandedRowRender}
                data={myStore.padvishRequestLicenseList.list} 
                isloading={isLoading} 
                onAddClick={addNewOnClick} 
                addButtonTitle={"درخواست جدید"}
                permission={permission} />
        </Row>

        {
            showLicenseCountDialog &&    
            <Modal
                visible={showLicenseCountDialog}
                onCancel={() => { setShowLicenseCountDialog(false);  loadPadvishRequestLicenses(); }}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <>
                    {isLoading === true && (
                                <Spinner/>
                    )}
                    {isLoading === false && (

                        <FormContainer title="تغییر تعداد کاربر لایسنس" onSubmit={onSubmitForm} onCancel={() =>{ setShowLicenseCountDialog(false);  loadPadvishRequestLicenses(); }} isLoading={isLoading} isSubmiting={isSubmiting} >
                            
                            <Row>
                                <Col lg={24} md={24} sm={24} xs={24}>
                                <Input
                                    type="text"
                                    name="licenseCount"
                                    placeholder={currentLicenseCount.toString()}
                                    value={licenseCount}
                                    onChange={(e) => handleChange(e)}
                                />
                                </Col>
                            </Row>

                        </FormContainer>

                    )}
                </>
                
            </Modal>
        }

{
            showRequestListDialog &&    
            <Modal style={{direction:'rtl'}} title="لیست درخواست های پادویش" open={showRequestListDialog} onOk={handleOk} onCancel={handleCancel} footer={[]} width={800}>
                <>
                    {isLoading === true && (
                                <Spinner/>
                    )}
                    {
                    isLoading === false && (                   
                        <Table  onRow={(record, rowIndex) =>
                         {
                            return {
                            onClick: event => 
                            { 
                                padvishLicenseTransferClick(selectedAccountId,record.prk_PadvishInstallRequest_AutoID)
                                setShowRequestListDialog(false);
                                loadPadvishRequestLicenses()
                            },
                            }
                            }
                            }   
                            scroll={{ x: 1500 }}
                            dataSource={padvishRequestList} columns={padvishcolumns}
                            /> 
                    )}
                </>
                
            </Modal>
        }
            </>
    )
}

export default PadvishLicenseRegistration;